/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_SettingsInputs */



/**
* | output |
* | --- |
* | "Settings" |
*
* @param {Profile_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_settings = /** @type {((inputs?: Profile_SettingsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_SettingsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ajustes")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Configurações")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni")
	return /** @type {LocalizedString} */ ("Settings")
});